import { DataType } from '@/util/index'
const LIST_INIT_STRUCTURE = {
  OPT_IN_SETTING: [
    {
      caption: 'Email',
      fieldKey: 'email',
      optInType: DataType.CustomerOptInType.EMAIL.value,
      isFourStatus: false,
      isTwoStatus: true,
      status: {
        total: 0,
        doNotCall: false,
        uncontactable: false,
        isMarketing: false,
        isOperation: false
      }
    },
    {
      caption: ' Cell Phone',
      fieldKey: 'cellPhone',
      optInType: DataType.CustomerOptInType.CELL_PHONE.value,
      isFourStatus: true,
      isTwoStatus: true,
      status: {
        total: 0,
        doNotCall: false,
        uncontactable: false,
        isMarketing: false,
        isOperation: false
      }
    },
    {
      caption: ' Home Phone',
      fieldKey: 'homePhone',
      optInType: DataType.CustomerOptInType.HOME_PHONE.value,
      isFourStatus: true,
      isTwoStatus: true,
      status: {
        total: 0,
        doNotCall: false,
        uncontactable: false,
        isMarketing: false,
        isOperation: false
      }
    },
    {
      caption: ' Work Phone',
      fieldKey: 'workPhone',
      optInType: DataType.CustomerOptInType.WORK_PHONE.value,
      isFourStatus: true,
      isTwoStatus: false,
      status: {
        total: 0,
        doNotCall: false,
        uncontactable: false,
        isMarketing: false,
        isOperation: false
      }
    }
  ],

  OPT_IN_ARRAY: [
    {
      name: 'email',
      display: false,
      style: 'far fa-at text-warning m-h-10 f-s-25',
      tooltip: 'Email'
    },
    {
      name: 'emailIsMarketing',
      display: false,
      style: 'fad fa-ad text-success',
      tooltip: 'Marketing Opt-in'
    },
    {
      name: 'emailIsOperation',
      display: false,
      style: 'fad fa-keyboard text-success',
      tooltip: 'Operation Opt-in'
    },
    {
      name: 'homePhone',
      display: false,
      style: 'far fa-phone-rotary text-warning m-h-10 f-s-25',
      tooltip: 'Home Phone'
    },
    {
      name: 'homePhoneIsMarketing',
      display: false,
      style: 'fad fa-ad text-success',
      tooltip: 'Marketing Opt-in'
    },
    {
      name: 'homePhoneIsOperation',
      display: false,
      style: 'fad fa-keyboard text-success',
      tooltip: 'Operation Opt-in'
    },
    {
      name: 'homePhoneNotCall',
      display: false,
      style: 'fad fa-phone-slash f-s-16 text-red',
      tooltip: 'Do Not Call'
    },
    {
      name: 'homePhoneUncontactable',
      display: false,
      style: 'fad fa-unlink f-s-16 text-red',
      tooltip: 'Uncontactable'
    },
    {
      name: 'cellPhone',
      display: false,
      style: 'fad fa-mobile text-warning m-h-10 f-s-25',
      tooltip: 'Cell Phone'
    },
    {
      name: 'cellPhoneIsMarketing',
      display: false,
      style: 'fad fa-ad text-success',
      tooltip: 'Marketing Opt-in'
    },
    {
      name: 'cellPhoneIsOperation',
      display: false,
      style: 'fad fa-keyboard text-success',
      tooltip: 'Operation Opt-in'
    },
    {
      name: 'cellPhoneNotCall',
      display: false,
      style: 'fad fa-phone-slash f-s-16 text-red',
      tooltip: 'Do Not Call'
    },
    {
      name: 'cellPhoneUncontactable',
      display: false,
      style: 'fad fa-unlink f-s-16 text-red',
      tooltip: 'Uncontactable'
    }
  ],
  EM_IN_ARRAY: [
    {
      name: 'workPhone',
      display: false,
      style: 'far fa-phone-rotary text-warning m-h-10 f-s-25',
      tooltip: 'Work Phone'
    },
    {
      name: 'workPhoneNotCall',
      display: false,
      style: 'fad fa-phone-slash f-s-16 text-red',
      tooltip: 'Do Not Call'
    },
    {
      name: 'workPhoneUncontactable',
      display: false,
      style: 'fad fa-unlink f-s-16 text-red',
      tooltip: 'Uncontactable'
    }
  ],
  INDICATOR: [
    {
      loanId: 1,
      key: DataType.IndicatorEnum.SSN.key,
      text: DataType.IndicatorEnum.SSN.text,
      indicatorCode: DataType.IndicatorEnum.SSN.value,
      right: true,
      firstCheckbox: false,
      count: ''
    },
    {
      loanId: 1,
      key: DataType.IndicatorEnum.BANKRUPTCIES.key,
      text: DataType.IndicatorEnum.BANKRUPTCIES.text,
      indicatorCode: DataType.IndicatorEnum.BANKRUPTCIES.value,
      firstCheckbox: false,
      count: '',
      secondCheckbox: false,
      latestIn: '',
      hasLatestIn: true
    },
    {
      loanId: 1,
      key: DataType.IndicatorEnum.NAMES.key,
      text: DataType.IndicatorEnum.NAMES.text,
      indicatorCode: DataType.IndicatorEnum.NAMES.value,
      right: true,
      firstCheckbox: false,
      count: ''
    },
    {
      loanId: 1,
      key: DataType.IndicatorEnum.LIENS.key,
      text: DataType.IndicatorEnum.LIENS.text,
      indicatorCode: DataType.IndicatorEnum.LIENS.value,
      firstCheckbox: false,
      count: '',
      secondCheckbox: false,
      latestIn: '',
      hasLatestIn: true
    },
    {
      loanId: 1,
      key: DataType.IndicatorEnum.EMAILS.key,
      text: DataType.IndicatorEnum.EMAILS.text,
      indicatorCode: DataType.IndicatorEnum.EMAILS.value,
      right: true,
      firstCheckbox: false,
      count: ''
    },
    {
      loanId: 1,
      key: DataType.IndicatorEnum.JUDGMENTS.key,
      text: DataType.IndicatorEnum.JUDGMENTS.text,
      indicatorCode: DataType.IndicatorEnum.JUDGMENTS.value,
      firstCheckbox: false,
      count: '',
      secondCheckbox: false,
      latestIn: '',
      hasLatestIn: true
    },
    {
      loanId: 1,
      key: DataType.IndicatorEnum.PHONES.key,
      text: DataType.IndicatorEnum.PHONES.text,
      indicatorCode: DataType.IndicatorEnum.PHONES.value,
      right: true,
      firstCheckbox: false,
      count: ''
    },
    {
      loanId: 1,
      key: DataType.IndicatorEnum.DOB.key,
      text: DataType.IndicatorEnum.DOB.text,
      right: true,
      indicatorCode: DataType.IndicatorEnum.DOB.value,
      firstCheckbox: false,
      count: ''
    },
    {
      loanId: 1,
      key: DataType.IndicatorEnum.HIGH_RISK.key,
      text: DataType.IndicatorEnum.HIGH_RISK.text,
      right: true,
      indicatorCode: DataType.IndicatorEnum.HIGH_RISK.value,
      firstCheckbox: false
    }
  ]
}

export { LIST_INIT_STRUCTURE }
